module.exports = __webpack_public_path__ + "img/Lead Management.0d8f20d8.svg";